<template>
  <div class="video-message">
    <!-- 视频缩略图区域 -->
    <div
      class="video-thumbnail"
      @click="openPlayer"
    >
      <video
        :src="videoUrl"
        preload="metadata"
        class="video-thumb"
        @loadedmetadata="onLoadedMetadata"
        ref="videoThumb"
      ></video>
      <!-- 播放按钮遮罩 -->
      <div class="play-overlay">
        <div class="play-button">
          <svg viewBox="0 0 24 24" width="36" height="36">
            <circle cx="12" cy="12" r="12" fill="rgba(0,0,0,0.5)" />
            <path fill="white" d="M8 5v14l11-7z" transform="translate(0, -1)" />
          </svg>
        </div>
      </div>
      <!-- 视频时长标签 -->
      <div class="video-duration" v-if="displayDuration">{{ displayDuration }}</div>
    </div>
    <!-- 视频播放弹窗 -->
    <el-dialog
      title="视频播放"
      :visible.sync="playerVisible"
      width="600px"
      top="5vh"
      :before-close="closePlayer"
      append-to-body
      custom-class="video-player-dialog"
    >
      <div class="video-player-container">
        <video
          :src="videoUrl"
          controls
          autoplay
          class="video-player"
          ref="videoPlayer"
        ></video>
      </div>
      <div class="video-player-footer">
        <el-button size="small" @click="downloadVideo">下载视频</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      playerVisible: false,
      videoDuration: 0,
    };
  },
  computed: {
    videoUrl() {
      if (!this.content) return '';
      return this.content.sightUrl || this.content.fileUrl || '';
    },
    fileName() {
      return this.content?.name || `video_${Date.now()}.mp4`;
    },
    duration() {
      if (!this.content) return 0;
      return this.content.duration || this.videoDuration || 0;
    },
    displayDuration() {
      if (!this.duration) return '';
      const seconds = Math.floor(this.duration);
      const m = Math.floor(seconds / 60);
      const s = seconds % 60;
      return m > 0 ? `${m}:${s < 10 ? '0' + s : s}` : `0:${s < 10 ? '0' + s : s}`;
    },
  },
  methods: {
    onLoadedMetadata() {
      if (this.$refs.videoThumb) {
        this.videoDuration = this.$refs.videoThumb.duration || 0;
      }
    },
    openPlayer() {
      this.playerVisible = true;
    },
    closePlayer() {
      this.playerVisible = false;
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
      }
    },
    downloadVideo() {
      const link = document.createElement('a');
      link.href = this.videoUrl;
      link.download = this.fileName;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>
.video-message {
  display: inline-block;
  border-radius: 8px;
  overflow: hidden;
}

.video-thumbnail {
  position: relative;
  width: 240px;
  max-width: 100%;
  height: 180px;
  background: #000;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  cursor: grab;
}

.video-thumbnail:active {
  cursor: grabbing;
}

.video-thumbnail.dragging {
  opacity: 0.7;
  transform: scale(0.98);
}

.video-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.2);
  transition: background 0.3s;
}

.play-overlay:hover {
  background: rgba(0, 0, 0, 0.35);
}

.play-button {
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-duration {
  position: absolute;
  bottom: 6px;
  right: 6px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 3px;
}

.video-player-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000;
  border-radius: 4px;
  overflow: hidden;
}

.video-player {
  max-width: 100%;
  max-height: 60vh;
}

.video-player-footer {
  text-align: right;
  padding-top: 10px;
}
</style>
